/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.1
// source: proto/sbe.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.proto = require('./sbe_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.SbeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.SbeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CreateSbeRequest,
 *   !proto.proto.CreateSbeResponse>}
 */
const methodDescriptor_SbeService_CreateSbe = new grpc.web.MethodDescriptor(
  '/proto.SbeService/CreateSbe',
  grpc.web.MethodType.UNARY,
  proto.proto.CreateSbeRequest,
  proto.proto.CreateSbeResponse,
  /**
   * @param {!proto.proto.CreateSbeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateSbeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CreateSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateSbeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateSbeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.SbeServiceClient.prototype.createSbe =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.SbeService/CreateSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_CreateSbe,
      callback);
};


/**
 * @param {!proto.proto.CreateSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateSbeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.SbeServicePromiseClient.prototype.createSbe =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.SbeService/CreateSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_CreateSbe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.UpdateSbeRequest,
 *   !proto.proto.UpdateSbeResponse>}
 */
const methodDescriptor_SbeService_UpdateSbe = new grpc.web.MethodDescriptor(
  '/proto.SbeService/UpdateSbe',
  grpc.web.MethodType.UNARY,
  proto.proto.UpdateSbeRequest,
  proto.proto.UpdateSbeResponse,
  /**
   * @param {!proto.proto.UpdateSbeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.UpdateSbeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.UpdateSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.UpdateSbeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.UpdateSbeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.SbeServiceClient.prototype.updateSbe =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.SbeService/UpdateSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_UpdateSbe,
      callback);
};


/**
 * @param {!proto.proto.UpdateSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.UpdateSbeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.SbeServicePromiseClient.prototype.updateSbe =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.SbeService/UpdateSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_UpdateSbe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeleteSbeRequest,
 *   !proto.proto.DeleteSbeResponse>}
 */
const methodDescriptor_SbeService_DeleteSbe = new grpc.web.MethodDescriptor(
  '/proto.SbeService/DeleteSbe',
  grpc.web.MethodType.UNARY,
  proto.proto.DeleteSbeRequest,
  proto.proto.DeleteSbeResponse,
  /**
   * @param {!proto.proto.DeleteSbeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DeleteSbeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.DeleteSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DeleteSbeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DeleteSbeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.SbeServiceClient.prototype.deleteSbe =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.SbeService/DeleteSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_DeleteSbe,
      callback);
};


/**
 * @param {!proto.proto.DeleteSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DeleteSbeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.SbeServicePromiseClient.prototype.deleteSbe =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.SbeService/DeleteSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_DeleteSbe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListSbeRequest,
 *   !proto.proto.ListSbeResponse>}
 */
const methodDescriptor_SbeService_ListSbe = new grpc.web.MethodDescriptor(
  '/proto.SbeService/ListSbe',
  grpc.web.MethodType.UNARY,
  proto.proto.ListSbeRequest,
  proto.proto.ListSbeResponse,
  /**
   * @param {!proto.proto.ListSbeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListSbeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListSbeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListSbeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.SbeServiceClient.prototype.listSbe =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.SbeService/ListSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_ListSbe,
      callback);
};


/**
 * @param {!proto.proto.ListSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListSbeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.SbeServicePromiseClient.prototype.listSbe =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.SbeService/ListSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_ListSbe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ItemSbeRequest,
 *   !proto.proto.ItemSbeResponse>}
 */
const methodDescriptor_SbeService_ItemSbe = new grpc.web.MethodDescriptor(
  '/proto.SbeService/ItemSbe',
  grpc.web.MethodType.UNARY,
  proto.proto.ItemSbeRequest,
  proto.proto.ItemSbeResponse,
  /**
   * @param {!proto.proto.ItemSbeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ItemSbeResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ItemSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ItemSbeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ItemSbeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.SbeServiceClient.prototype.itemSbe =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.SbeService/ItemSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_ItemSbe,
      callback);
};


/**
 * @param {!proto.proto.ItemSbeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ItemSbeResponse>}
 *     Promise that resolves to the response
 */
proto.proto.SbeServicePromiseClient.prototype.itemSbe =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.SbeService/ItemSbe',
      request,
      metadata || {},
      methodDescriptor_SbeService_ItemSbe);
};


module.exports = proto.proto;

